/* ============================================================
 *  Texte des CGV charge a la demande dans le popup
 *  Pose le 20/10/2026 (audit SEO giuradoc §P8).
 *
 *  Avant : les 968 mots des conditions generales etaient injectes par Liquid
 *  dans le HTML de TOUTES les pages du site, dans les 5 langues, et leurs 13
 *  titres etaient les seuls h2 du document sur une fiche produit.
 *
 *  Ici : la coque du popup reste dans la page, le texte arrive de la page des
 *  conditions elle-meme (`?view=ajax_term_condition`), dans la langue courante.
 *
 *  Pour que l'usage soit identique, le chargement ne part pas au clic mais au
 *  premier signe d'intention : survol, toucher ou focus du lien qui ouvre le
 *  popup. Le clic reste un filet de securite. L'ecoute est posee en phase de
 *  CAPTURE sur `document`, parce que le gestionnaire du theme (theme.js,
 *  initGlobalCheckbox) appelle `stopPropagation()` sur ce meme clic.
 *
 *  La case « j'accepte les conditions » n'est pas touchee : c'est elle qui
 *  debloque le bouton de commande, elle vit ailleurs, et elle ne depend pas de
 *  ce texte. Si le chargement echoue, le popup affiche un lien vers la page des
 *  conditions : jamais un popup vide, jamais un parcours d'achat bloque.
 * ============================================================ */
(function () {
  'use strict';

  var etat = 'vide';

  function boite() {
    return document.querySelector('[data-term-condition-content][data-term-condition-src]');
  }

  function repli(box) {
    var url = box.getAttribute('data-term-condition-page');
    var titre = box.getAttribute('data-term-condition-titre') || url;
    if (!url) return;
    var p = document.createElement('p');
    var a = document.createElement('a');
    a.setAttribute('href', url);
    a.textContent = titre;
    p.appendChild(a);
    box.appendChild(p);
  }

  function charger() {
    if (etat !== 'vide') return;
    var box = boite();
    if (!box) return;
    var src = box.getAttribute('data-term-condition-src');
    if (!src) return;
    etat = 'encours';
    fetch(src, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        if (!html || !html.trim()) throw new Error('reponse vide');
        box.innerHTML = html;
        etat = 'charge';
      })
      .catch(function () {
        etat = 'charge';
        if (!box.textContent.trim()) repli(box);
      });
  }

  function declencheur(cible) {
    if (!cible || !cible.closest) return null;
    return cible.closest('[data-term-condition]');
  }

  ['pointerover', 'touchstart', 'focusin', 'click'].forEach(function (nom) {
    document.addEventListener(
      nom,
      function (e) {
        if (declencheur(e.target)) charger();
      },
      true
    );
  });

  /* Le popup peut aussi etre ouvert par du code du theme (classe sur le body).
     On surveille cette classe : c'est le dernier moment utile pour charger. */
  if (typeof MutationObserver === 'function') {
    var obs = new MutationObserver(function () {
      if (document.body.classList.contains('term-condition-show')) charger();
    });
    obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
})();
